import {createApi} from "@reduxjs/toolkit/query/react";
import {baseQueryWithReAuth} from "@/store/api/baseQueryWithReAuth";

export interface Country {
    id: number;
    title: string;
    type: string;
    flag: string;
    description: string;
}

export const countryApi = createApi({
    reducerPath: "countryApi",
    baseQuery: baseQueryWithReAuth,
    endpoints: (builder) => ({
        getCountries: builder.query<Country[], void>({
            query: () => "/country/",
        }),
    }),
});

export const { useGetCountriesQuery } = countryApi;

